import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import ConsentPage from "../../components/auth/ConsentPage";
import { useAuth } from "../../context/AuthContext";

// Adult post-signup Ley 1581 consent step. Minors pass through GuardianGate;
// after verification they continue to the normal onboarding/dashboard gates.
const ConsentRoute = () => {
  const navigate = useNavigate();
  const { pendingConsentData, completeConsent } = useAuth();

  if (!pendingConsentData || pendingConsentData.isMinor) {
    return <Navigate to="/athlete/dashboard" replace />;
  }

  return (
    <ConsentPage
      athleteId={pendingConsentData.athleteId}
      isMinor={pendingConsentData.isMinor}
      guardianEmail={pendingConsentData.guardianEmail}
      onComplete={() => {
        completeConsent();
        navigate("/athlete/onboarding", { replace: true });
      }}
    />
  );
};

export default ConsentRoute;
